import { Component, OnInit }  from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MasterDataService } from '../masterdata/masterdata.service';
import { DeliveryPackage, ShipmentStatus, SelectableShipmentStatus } from './deliveryPackage';
import { MessagesService } from '../messages/messages.service';
import { LazyLoadEvent, ConfirmationService, SelectItem } from 'primeng/api';
import { ApgDeliveryService } from './apg-delivery.service';
import { ErrorHandler } from '../utils/error-handler';
import { DatePipe } from '@angular/common';
import { BoxPackage, BoxDetails } from './box-Package';
import { saveAs as saveByFileSaver } from "file-saver";

@Component({
  selector: 'app-apg-delivery',
  templateUrl: './apg-delivery.component.html',
  styleUrls: ['./apg-delivery.component.css']
})
export class ApgDeliveryComponent implements OnInit {
  cols: any[];
  loading: boolean;
  puid: string;
  newShipment: boolean;
  displayDialog: boolean;
  deliveryform: FormGroup;
  senderList: SelectItem[]= [];
  deliveryPackages: DeliveryPackage[];
  deliverySamplestoDisplay: DeliveryPackage[];
  deliveryPackage: DeliveryPackage;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedLabId: string;
  blocked: boolean;
  totalRecords: any;
  shipstatus: ShipmentStatus;
  selectedDeliveryPackage: DeliveryPackage;
  deliveryStatusList: SelectableShipmentStatus[];
  SelectableShipmentStatus: SelectableShipmentStatus;
  deliveryExpectedOn: Date;
  sentOn: Date;
  uploadedFiles: any[] = [];
  cachedSender: string;
  uploaded: boolean;
  statusCols:any[];
  isBoxLink='boxlink';
  isStatus='status';
  boxPackage:BoxPackage;
  displayBoxDialog:boolean=false;
  boxDetails:BoxDetails;
  boxDetailsList:BoxDetails[]=[];
  selectedSender: string;
  boxID: string;
  shipmentId:string;
  useGivenShipment:boolean;
  exportBoxes: boolean;
  selectedSenderForFilter : string;
  fromDate: Date;
  toDate: Date;
  selectedShipmentStatus: SelectableShipmentStatus;
  selectedDeliveryID : string;
  selectedBoxID : string;
  shortSenderValueMap = new Map();

  constructor(private fb: FormBuilder, private _messagesService: MessagesService, public datepipe: DatePipe,
    private deliveryService: ApgDeliveryService, private masterDataService: MasterDataService, private confirmationService: ConfirmationService) { }
  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');
    this.populateSenders();
    this.loading = true;
    this.loading = false;
    this.deliveryform = this.fb.group({
      'puid': new FormControl('', Validators.required),
      'sender': new FormControl('', Validators.required),
      'sentOn': new FormControl('', Validators.required),
      'deliveryExpectedOn': new FormControl('', Validators.required),
      'receptionOn': new FormControl('',),
      'lastModifiedDate': new FormControl('',),
      'sample': new FormControl('',),
      'box': new FormControl('',),
      'problem': new FormControl('',),
      'comments': new FormControl('',),
      'problemLog': new FormControl('',),
      'lab': new FormControl('',),
      'shipmentStatus': new FormControl('', Validators.required),
      'shipmentexcel': new FormControl('',)
    });

    // Table Column headings
    this.cols = [
      { field: '_id', header: 'ID', width:'6%' },
      { field: 'deliveryStatus', header: 'Status',width:'6%' },
      { field: 'samplesCount', header: 'Gesamt', width: '6%'},
      { field: 'reusedTrue', header:'Resued True', width:'6%'},
      { field: 'reusedFalse', header: 'Reused False', width:'6%'},
      { field: 'lastModifiedDate', header: ' Received', date: true, format: 'dd.MM.yyyy HH:mm ', width: '8%'},
      { field: 'str', header: 'STR', width: '3%'},
      { field: 'strp', header: 'STR-P', width: '3%'},
      { field: 'snp',  header: 'SNP', width: '3%'},
      { field: 'test', header: 'GeneTest', width: '3%'},
      { field: 'excel', header: 'Report', width: '3%'}
    ];
    this.statusCols = [
      { field: 'boxId', header: 'BoxID', width: '15%' },
      { field: 'status', header: 'Status', width: '25%' },
      { field: 'announcedCount', header: 'Announced',width:'10%' },
      { field: 'receivedCount', header: 'Rec. Total',width:'10%'},
      { field: 'ncReceivedCount', header: 'Rec. NC',width:'10%'},
      { field: 'additionalCount', header: 'Additional',width:'10%'},
      { field: 'problemCount', header: 'Problem',width:'10%'  },
      { field: 'missingCount', header: 'Missing',width:'10%' }
    ];
    this.deliveryStatusList = [
      { name: 'Announced', value: ShipmentStatus.ANNOUNCED },
      { name: 'Received ', value: ShipmentStatus.RECEIVED }
    ]
	;

  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploaded = true;
      this.deliveryform.get('shipmentexcel').setValue(file);
    }
  }

  populateSenders() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            let tempValue: any = value;
            let labelValue = tempValue.senderShortName ? tempValue.senderShortName : key;
            this.shortSenderValueMap.set(key,labelValue);
            this.senderList.push({label:labelValue,value:key});
          });
          this.senderList.sort((item1,item2)=>item1.label.localeCompare(item2.label));
        }
      },
    );
  }
  populateTable(skip: number, limit: number) {
    this.blocked = true;
    var deliveryStatus='';
    if(this.selectedShipmentStatus){
      deliveryStatus=ShipmentStatus[this.selectedShipmentStatus.value];
    }
    this.deliveryService.getDelivery(this.getQueryString(),deliveryStatus, skip, limit).subscribe(
      results => {
        this.deliverySamplestoDisplay = results.data[0].data;
        this.formatDeliverySamplesToDisplay(this.deliverySamplestoDisplay);
        if (results.data[0].metadata.length > 0) {
          this.totalRecords = results.data[0].metadata[0].total;
        }else{
          this.totalRecords =0;
        }
        this.blocked = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      })
  }
  private formatDeliverySamplesToDisplay(deliverySamplestoDisplay:any) {
    for (let i = 0; i < deliverySamplestoDisplay.length; i++) {
      if (deliverySamplestoDisplay[i].lastModifiedDate) {
        let time = deliverySamplestoDisplay[i].lastModifiedDate.toString();
        deliverySamplestoDisplay[i].lastModifiedDate = this.timeconv(time);
      }
      if (deliverySamplestoDisplay[i].creationDate) {
        deliverySamplestoDisplay[i].creationDate = null;
      }
    }
  }

  timeconv(d: any): Date {
    let d1 = d.split(" ");
    let date = d1[0].split(".");
    let time = d1[1].split(":");
    let dd = date[0];
    let mm = date[1];
    let yy = date[2];
    let hh = time[0];
    let min = time[1];
    let retdate = new Date(mm + '/' + dd + '/' + yy + ' ' + hh + ':' + min + ' UTC');
    date.toString()
    return retdate;
  }
  onSubmit(value: string) {
    this.blocked = true;
    if (this.SelectableShipmentStatus) {
      this.deliveryPackage.shipmentStatus = this.SelectableShipmentStatus.value;
    }
    this.deliveryPackage.lab = this.selectedLabId;
    if (this.sentOn)
      this.deliveryPackage.sentOn = this.sentOn;
    if (this.deliveryExpectedOn)
      this.deliveryPackage.deliveryExpectedOn = this.deliveryExpectedOn;
    const formData = new FormData();
    formData.append('file', this.deliveryform.get('shipmentexcel').value);
    if (this.newShipment) {
      formData.append('delivery', JSON.stringify(this.deliveryPackage));
      this.deliveryService.saveDelivery(formData).subscribe(
        result => {
          if (result.data) {
            this.selectedDeliveryPackage = result.data;
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Delivery Created!',
              detail: 'Delivery ' + this.selectedDeliveryPackage.shipmentId + ' has been createdfor user ' + this.selectedDeliveryPackage.puid,
            });
            this.blocked = false;
            this.loading = true;
            this.populateTable(0, 10);
            this.loading = false;
          }
        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    }
    else {
      this.displayConfirm(formData);
    }
    this.displayDialog = false;
  }

  displayConfirm(formData: FormData) {
    if (this.deliveryPackage.sender !== this.cachedSender && this.deliveryPackage.isUploaded && this.uploaded) {
      this.confirmationService.confirm({
        message: "Changing a sender and uploading a new file will delete information that was already uploaded!",
        header: "Do you want to change the sender and upload again?",
        accept: () => {
          formData.append('delivery', JSON.stringify(this.deliveryPackage));
          this.updateDelivery(formData);
        },
        reject: () => {
          this.blocked = false;
        }
      });
    } else if (this.deliveryPackage.sender !== this.cachedSender && this.deliveryPackage.isUploaded) {
      this.deliveryPackage.deleteSamples = true;
      this.confirmationService.confirm({
        message: "Already uploaded information will be lost",
        header: "Do you want to change the sender?",
        accept: () => {
          this.deliveryPackage.deleteSamples = true;
          formData.append('delivery', JSON.stringify(this.deliveryPackage));
          this.updateDelivery(formData);
        },
        reject: () => {
          this.blocked = false;
        }
      });
    }
    else if (this.deliveryPackage.isUploaded && this.uploaded) {
      this.confirmationService.confirm({
        message: "Uploading a new file will delete information that was already uploaded!",
        header: "Do you want to upload again?",
        accept: () => {
          formData.append('delivery', JSON.stringify(this.deliveryPackage));
          this.updateDelivery(formData);
        },
        reject: () => {
          this.blocked = false;
        }
      });
    }
    else {
      formData.append('delivery', JSON.stringify(this.deliveryPackage));
      this.updateDelivery(formData);
    }
  }

  updateDelivery(formData: FormData) {
    this.deliveryService.updateDelivery(formData).subscribe(
      result => {
        if (result.data) {
          this.selectedDeliveryPackage = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Delivery Updated!',
            detail: 'Delivery ' + this.selectedDeliveryPackage.shipmentId + ' has been Updated for user ' + this.selectedDeliveryPackage.puid,
          });
        }
        this.loading = true;
        this.deliveryPackage = null;
        this.populateTable(0, 10);
        this.loading = false;
      },
      error => {
        this.blocked = false;
        this.deliveryPackage = null;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );

  }

  cloneDeliveryPackage(deliveryPackage: DeliveryPackage): DeliveryPackage {
    let sample = new DeliveryPackage();
    for (let prop in deliveryPackage) {
      sample[prop] = deliveryPackage[prop];
    }
    return sample;
  }

  loadLazy(event: LazyLoadEvent) {
    this.loading = true;
    this.populateTable(event.first, event.rows)
    this.loading = false;
  }

  onDeleteClick(): void {
    this.blocked = true;
    this.deliveryService.deleteDelivery(this.deliveryPackage).subscribe(
      result => {
        if (result.data) {
          this.selectedDeliveryPackage = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Delete successful!',
            detail: 'Delivery ' + this.selectedDeliveryPackage.shipmentId + ' has been deleted for user ' + this.selectedDeliveryPackage.puid,
          });
        }
        this.loading = true;
        this.populateTable(0, 10);
        this.loading = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
    this.deliveryPackage = null;
    this.displayDialog = false;
  }
  
  getBoxDetail(shipmentId)
{
    this.displayBoxDialog=true;
    this.loading = true;
    this.deliveryService.getBoxDetails(this.selectedLabId, shipmentId).subscribe(
      results => {
        this.boxPackage=results.data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      })
  }

  preventDialog = (event) => {
    if(this.SelectableShipmentStatus && this.SelectableShipmentStatus.value===ShipmentStatus.ANNOUNCED){
      return true;
    }
    else{
      event.preventDefault();
      event.stopPropagation();
      let message = { severity: 'error', summary: 'File upload is not possible as status in not ANNOUNCED' };
      this._messagesService.addErrorMessage(message);
      return false;
    }
  }

  clear() {
    this.selectedSender = null;
    this.boxID = null;
  }

  receiveBox(boxID:string, selectedSender: string) {
    this.blocked = true;
    this.deliveryService.receiveBox(this.selectedLabId, boxID, selectedSender).subscribe(
      results => {
        if(results.data){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: results.data.summary,
            detail: results.data.detail,
          });
        }
        if (results.data.showTimeDialogue) {
          this.confirmationService.confirm({
            message: 'There is a shipment : '+ results.data.showTimeDialogue+ 'For the sender, And it is been more than a hour after the last box reception, do you want to add this box to same shipment?',
            header: 'Box added recently',
            accept: () => {
              this.receiveBoxInShipment(this.selectedLabId, boxID, selectedSender,results.data.showTimeDialogue,true);
              },
            reject: () => {
              this.receiveBoxInShipment(this.selectedLabId, boxID, selectedSender,results.data.showTimeDialogue,false);
              }
          });
        } else {
          if (results.data.shipmentID) {
            this.confirmationService.confirm({
              message: 'Box : ' + boxID + ' newly created and added to delivery : ' + results.data.shipmentID + ' Was this the last box of this delivery?',
              header: 'Is last box?',
              accept: () => {
                this.updateStatus(this.selectedLabId, results.data.shipmentID, "COMPLETED");
              },
              reject: () => {
                this.boxID = null;
              }
            });
          }
        }
        this.blocked = false;
        this.populateTable(0, 10);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
  }

  deleteBox(){
    this.blocked = true;
    this.deliveryService.deleteBox(this.selectedLabId, this.boxID, this.selectedSender).subscribe(
      results => {
        if(results.data){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: results.data.summary,
            detail: results.data.detail,
          });
        }
        this.blocked = false;
        this.boxID = null;
        this.populateTable(0, 10);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
  }

  getReceivedStatus(isReceived: boolean, receivedDate: string){
    if(isReceived)
      return 'Received on ' + this.datepipe.transform(this.timeconv(receivedDate), 'dd.MM.yyyy HH:mm ');
  }

  reportDelivery( shipmentId: string, sender: string){
    this.blocked = true;
    this.deliveryService.downloadExcel(this.selectedLabId, shipmentId).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        let filename = shipmentId + '_' + sender + '_' + this.datepipe.transform(new Date(), "dd.MM.yy HH:mm") + '.xlsx';
        saveByFileSaver(blob, filename);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Excel has been downloaded',
        });
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      })
  }
  
  updateStatus(selectedLabId: string, shipmentId: string, status: string) {
    this.deliveryService.updateShipmentStatus(selectedLabId, shipmentId, status).subscribe(
      results => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Updated Shipment Status!',
          detail: 'Shipment status : ' + status + ' updated for shipment ID :' + shipmentId,
        });
        this.blocked = false;
        this.boxID = null;
        this.populateTable(0, 10);
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  receiveBoxInShipment(lab:string,boxId:string,sender:string,shipemtId:string,useGivenShipment:boolean) {
    this.blocked = true;
    this.deliveryService.receiveBoxForShipment(lab, boxId, sender,shipemtId,useGivenShipment).subscribe(
      results => {
        if(results.data){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: results.data.summary,
            detail: results.data.detail,
          });
        }
        if (results.data.shipmentID) {
          this.confirmationService.confirm({
            message: 'Box : '+this.boxID+ ' newly created and added to delivery : '+ results.data.shipmentID+ ' Was this the last box of this delivery?',
            header: 'Is last box?',
            accept: () => {
              this.updateStatus(this.selectedLabId, results.data.shipmentID, "COMPLETED");
            },
            reject: () => { }
          });
        }
        this.blocked = false;
        this.boxID = null;
        this.populateTable(0, 10);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
  }
  searchDelivery() {
    this.loading = true;
    this.populateTable(0, 10)
    this.loading = false;
  }

  export() {
    this.blocked = true;
    let filename : string;
    var shipmentStatus='';
    if(this.selectedShipmentStatus){
      shipmentStatus=ShipmentStatus[this.selectedShipmentStatus.value];
    }
    let queryString = this.getQueryString();
    this.deliveryService.exportShipment(queryString,shipmentStatus).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        var date = this.datepipe.transform(new Date(), "dd.MM.yyyy");
        if(this.selectedSenderForFilter && this.selectedShipmentStatus){
          filename = 'Deliveries_'.concat(date).concat('_').concat(this.shortSenderValueMap.get(this.selectedSenderForFilter)).concat('_').concat(this.selectedShipmentStatus.name).concat('.xlsx');
        }
        else if(this.selectedSenderForFilter){
          filename = 'Deliveries_'.concat(date).concat('_').concat(this.shortSenderValueMap.get(this.selectedSenderForFilter)).concat('.xlsx');
        }
        else if(this.selectedShipmentStatus){
          filename = 'Deliveries_'.concat(date).concat('_').concat(this.selectedShipmentStatus.name).concat('.xlsx'); 
        }
        else{
          filename = 'Deliveries_'.concat(date).concat('.xlsx');
        }      
    
        saveByFileSaver(blob, filename);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Excel has been downloaded',
        });
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  clearSelection() {
    this.selectedBoxID = "";
    this.selectedDeliveryID = "";
    this.toDate = null;
    this.fromDate = null;
    this.selectedShipmentStatus = null;
    this.selectedSenderForFilter = null;
    this.searchDelivery();

  }

  getQueryString() {
    let queryString = "";
      if (this.selectedDeliveryID) {
        queryString = queryString.concat("delivery==").concat(this.selectedDeliveryID).concat(";");
      }
      if (this.fromDate) {
        queryString = queryString.concat("creationDate=ge=").concat(this.datepipe.transform(this.fromDate, 'MM/dd/yyyy')).concat(";");
      }
      if (this.toDate) {
        let toDatePlusOne = new Date(this.toDate);
        toDatePlusOne.setDate(toDatePlusOne.getDate() + 1)
        queryString = queryString.concat("creationDate=le=").concat(this.datepipe.transform(toDatePlusOne, 'MM/dd/yyyy')).concat(";");
      }
    queryString = queryString.substring(0, queryString.length - 1);
    return queryString;
  }
  reportDeliveryForSamples( delivery: string, deliveryStatus: string){
    this.blocked = true;
    this.deliveryService.downloadExcelForDelivery(delivery,deliveryStatus).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        let filename = delivery + '_' + deliveryStatus + '_' + this.datepipe.transform(new Date(), "dd.MM.yy HH:mm") + '.xlsx';
        saveByFileSaver(blob, filename);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Excel has been downloaded',
        });
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      })
  }
 }
